import { useQuery } from '@apollo/client';
import React from 'react';
import i18next from 'core/i18n';
import { PriorNegotiation } from '@indigo-ag/schema';

import { ContractList } from '../ContractList/ContractList';
import styled from 'styled-components';
import { LoadingIndicator, NoResultsFound } from 'shared';
import { getPriorNegotiations } from '../../../queries';
import { orderBy } from 'lodash';

const ContractHistoryContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`;

interface Props {
  financingId: string;
}

export const ContractSection: React.FunctionComponent<Props> = ({ financingId }) => {
  const priorNegotiationsQuery = useQuery(getPriorNegotiations, {
    variables: { agFinancingId: financingId }
  });
  const priorNegotiations: PriorNegotiation[] = priorNegotiationsQuery?.data
    ? [...priorNegotiationsQuery?.data?.priorNegotiations]
    : [];

  const sortedPriorNegotiations = orderBy(priorNegotiations, ['date'], ['desc']);

  return (
    <>
      {priorNegotiationsQuery.loading ? (
        <LoadingIndicator />
      ) : (
        <ContractHistoryContainer>
          {sortedPriorNegotiations?.length ? (
            <ContractList priorNegotiations={sortedPriorNegotiations} title={i18next.t('contractHistory')} />
          ) : (
            <NoResultsFound />
          )}
        </ContractHistoryContainer>
      )}
    </>
  );
};
